import axios from 'axios';
import { URL } from '../config/api';

// Turns a category name into a URL slug: "Father's Day" -> "fathers-day"
export const slugify = (name) =>
    String(name || '')
        .trim()
        .toLowerCase()
        .replace(/['\u2019]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

let catalogPromise = null;

// Fetches the full cut-file catalog once per session and shares it between
// pages (Home grid + Stickers browse). Categories come back cleaned:
// trimmed name, Slug, live Count, with unnamed/empty categories removed.
export const loadCatalog = () => {
    if (!catalogPromise) {
        catalogPromise = axios
            .get(`${URL}/sticker/get_sticker_new.php`)
            .then((res) => {
                const stickers = res.data.Data || [];
                const rawCategories = res.data.Data1 || [];

                const countByCategory = {};
                // Most-downloaded cut file per category, used as the tile image.
                const coverByCategory = {};
                for (const sticker of stickers) {
                    countByCategory[sticker.CategoryId] =
                        (countByCategory[sticker.CategoryId] || 0) + 1;
                    const current = coverByCategory[sticker.CategoryId];
                    if (!current || Number(sticker.Downloads) > Number(current.Downloads)) {
                        coverByCategory[sticker.CategoryId] = sticker;
                    }
                }

                const categories = rawCategories
                    .map((category) => ({
                        ...category,
                        Name: String(category.Name || '').trim(),
                        Slug: slugify(category.Name),
                        Count: countByCategory[category.Id] || 0,
                        CoverImage: coverByCategory[category.Id]
                            ? coverByCategory[category.Id].ImageUrl
                            : category.Image,
                    }))
                    .filter((category) => category.Name !== '' && category.Count > 0)
                    .sort((a, b) => Number(a.SortIndex) - Number(b.SortIndex));

                return { stickers, categories };
            })
            .catch((error) => {
                catalogPromise = null; // allow a retry on the next call
                throw error;
            });
    }
    return catalogPromise;
};

export const findCategoryBySlug = (categories, slug) =>
    categories.find((category) => category.Slug === slug);

// Most-populated categories, for the home grid.
export const topCategories = (categories, count) =>
    [...categories]
        .filter((category) => category.CoverImage)
        .sort((a, b) => b.Count - a.Count)
        .slice(0, count);
